import React, { useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import ModalMakeMeAFileByDate from '../modal/ModalMakeMeAFileByDate.comp'
import './MainStyle.css'
import { Avatar, Badge, Box, Drawer, FormControl, InputLabel, LinearProgress, MenuItem, Rating, Select, TextField, Tooltip, Typography } from '@mui/material'
import LoginContext from '../../context/login_context/LoginContext'
import TaskComp from '../../component/TaskComp.component'
import { useContext } from 'react'

// icons

import ChecklistIcon from '@mui/icons-material/Checklist';
import TimelineIcon from '@mui/icons-material/Timeline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SaveIcon from '@mui/icons-material/Save';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ConstructionIcon from '@mui/icons-material/Construction';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import RefreshIcon from '@mui/icons-material/Refresh';
import { PiDownloadBold } from "react-icons/pi";
import { TbStatusChange } from "react-icons/tb";
import { FaListCheck } from "react-icons/fa6";
import { IoLayersOutline } from "react-icons/io5";
import FilterAltIcon from '@mui/icons-material/FilterAlt';//ico filter
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';//ico without filter
import { FaArrowDownUpLock } from "react-icons/fa6";

import { GetOts } from '../../api/GetOts.api'//ok
import { GetTasks } from '../../api/GetTasks.api'//ok
import { StatusToRevcn } from '../../api/StatusToRevcn.api'//ok
import { ModalLoaded } from '../../component/ModalLoaded.component'
import { Put_AddNote } from '../../api/Put_AddNote.api'//ok
import { useNavigate } from 'react-router-dom'
import { OtPdf_big } from './OtPdf_big.page'
import ObtenerUserByRut from '../../api/OT/ObtenerUserByRut.api'
import { ChangeResponsible } from '../../api/OT/ChangeResponsible.api'
import { BkpReasignacionOT } from '../../api/OT/BkpReasignacionOT.api'

export default function Ot() {
	/** variables y mutadores */
	const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);
	// console.log(LoginState);
	const [VisibleModal, setVisibleModal] = useState(false)
	const [NotaEdit, setNotaEdit] = useState("")
	const [valueRating, setValueRating] = React.useState(0);
	const [OtsBault, setOtsBault] = useState([]);
	const [OtsBaultBKP, setOtsBaultBKP] = useState([]);
	const [TasksBault, setTasksBault] = useState([]);
	const [OtsSelected, setOtsSelected] = useState([]);

	const [MenuFilter, setMenuFilter] = useState(false);
	const [FechaFilter, setFechaFilter] = useState('');
	const [OTFilter, setOTFilter] = useState('');

	const [woFolioAsignacion, setwoFolioAsignacion] = useState('');
	const [SelAsignacion, setSelAsignacion] = useState("");
	const [UserDataCompleta, setUserDataCompleta] = useState([]);

	const [ModalLoadded, setModalLoadded] = useState(false);
	const [ModalLoadded_, setModalLoadded_] = useState(false);
	const [Texto, setTexto] = useState('');

	const [controlChangeOT, setControlChangeOT] = useState(1);

	const [dataOT, setDataOT] = useState()

	const navigate = useNavigate();

	/** MUTADORES DE ESTADO DRAWER PARA ASGNACION DE OT*/
	const [stateReasign, setStateReasign] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawerReasign = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
		setwoFolioAsignacion('')
		setSelAsignacion("")
    setStateReasign({ ...stateReasign, [anchor]: open });
  };
	
	/** MUTADORES DE ESTADO DRAWER */
	const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
	setNotaEdit("")
	setOtsSelected([])
	setState({ ...state, [anchor]: open });
  };
	/** Funciones y metodos */
		/** obtiene las OTs ligadas al rut  */
	const ObtainOtsApi = async () => {
		setTexto('Se estan Cargando las OTs')
		await setModalLoadded(true)
		const ots = await GetOts({codigo:LoginState.rut, planta:LoginState.planta})
		// console.log(ots);

		// // elimina las OT repetidas
		// let elfiltro = await ots.filter(o =>  hash[o.wo_folio] ? false : hash[o.wo_folio] = true)
		// // console.log(elfiltro);

		// ordena por wo_folio(numero de OT)
		let orden = await ots.sort((a, b) => b.id_work_order - a.id_work_order )
		// console.log(orden);

		const resultado = Object.values(
			orden.reduce((acc, item) => {
				const id = item.id_work_order;
				if (!acc[id]) {
					// Clonamos el objeto para no modificar el original
					acc[id] = { ...item, cantidad: 0 };
				}
				acc[id].cantidad++;
				return acc;
			}, {})
		);
		// console.log(resultado)
		// console.log(resultado)
		// setOtsBaultBKP(resultado);
		// setOtsBault(resultado);
		// await setModalLoadded(false)

		//cliclo que consulta cada ot para traer las tareas de cada ot
		for (let tsk = 0; tsk < resultado.length; tsk++) {
			let tsk_ = resultado[tsk];
			// let tasks_n = await GetTasks({wofolio:tsk_.wo_folio, planta:LoginState.planta})
			// tsk_["tareas"] = tasks_n.length

			const BkpReasign = await BkpReasignacionOT({ACTION:"GET",DATA:{OT: tsk_.wo_folio}})
			tsk_["REASIGN_"] = BkpReasign ? true : false
		}
		// console.log(resultado)
		setOtsBaultBKP(resultado);
		setOtsBault(resultado);
		await setModalLoadded(false)
	}

	const Obtener_UserByRut = async () => {
		if(LoginState.cargo === "EXTERNO"){
			const usr_byRut = await ObtenerUserByRut({ACTION:'READ', DATA:{CODIGO:LoginState.rut}})
			let toSelectAsigned = usr_byRut[0].CONTACTOS.map(usr=>{
				return {value:usr,label:usr}
			})
			setUserDataCompleta(toSelectAsigned)
			// console.log(toSelectAsigned)
		}else{
			const usr_byRut = await ObtenerUserByRut({ACTION:'READ', DATA:{CARGO:LoginState.cargo,PLANTA:LoginState.planta}})
			let toSelectAsigned = usr_byRut.map(usr=>{
				let {CODIGO,NOMBRE} = usr
				return {value:CODIGO,label:NOMBRE}
			})
			setUserDataCompleta(toSelectAsigned)
			// console.log(toSelectAsigned)
		}
	}

	 /** abre el menu con las tareas de la ot seleccionada */
	const GetTAsksApi = async (wofolio) => {
		const tasks = await GetTasks({wofolio, planta:LoginState.planta})
		setTasksBault(tasks)
		// console.log('tasks',tasks);// print de tareas
	}

		// filtra por fecha las ot's
	const FiltroPorFecha = async () => {
		if(FechaFilter!== ''){
			if(OTFilter !== ''){
				// console.log('filtro fecha ot')
				let filterFecha = await OtsBaultBKP.filter(fl=> fl.date_maintenance.startsWith(FechaFilter) && String(fl.wo_folio).match(OTFilter.toUpperCase()))
				setOtsBault(filterFecha)
				setMenuFilter(!MenuFilter)
			}else{
				// console.log('filtro fecha')
				let filterFecha = await OtsBaultBKP.filter(fl=> fl.date_maintenance.startsWith(FechaFilter))
				setOtsBault(filterFecha)
				setMenuFilter(!MenuFilter)
			}
			return
		}
		if(OTFilter !== ''){
			// console.log('numero ot')
			let filterFecha = await OtsBaultBKP.filter(fl=> String(fl.wo_folio).match(OTFilter.toUpperCase()))
			setOtsBault(filterFecha)
			setMenuFilter(!MenuFilter)
			return
		}
		
	}

	// genera el PDF de la OT seleccionada
	const GenerarPDF_NOW = async (otData) => {
		let {wo_folio} = otData
		setTexto('Estamos Generando el PDF para usted.')
		await setModalLoadded(true)
		const tasks = await GetTasks({wofolio:wo_folio, planta:LoginState.planta})
		// console.log('tasks',tasks, wo_folio);
		setDataOT({ OT: otData, TASK: tasks });
		await setModalLoadded_(true)

		// await navigate("/pdf", { state: { OT: otData, TASK: tasks } });
		await setModalLoadded(false)
	}
	
	const MenuCrud = async (wofolio,ots) => {
		// console.log(ots.wo_folio)
		setOtsSelected([ots]);
		setTexto('Se estan Cargando las tareas.')
		await setModalLoadded(true)
		// console.log('WO_FOLIO',wofolio);
		await GetTAsksApi(wofolio)
		// toggleDrawer('right', true)
		setState({ ...state, ['right']: true });
		await setModalLoadded(false)
	}

	/** cambia el status de la ot */
	const HandleChangeStatus = async (wo_folio) => {
		// console.log('Vamos a cambiar el estado de esta OT', wo_folio);
		let toRevcn = window.confirm(`Esta seguro de enviar la ${wo_folio} a revision?`)
		if(toRevcn){
			let chg_status = await StatusToRevcn({wo_folio:wo_folio,status:2,planta:LoginState.planta})
			if(chg_status){
				// console.log('el status a cambiado');
				await ObtainOtsApi()
			}
		}
	}

	/** guarda la anota en la OT */
	const SaveNoteInOT = async (wofolio) => {
		// console.log(NotaEdit, wofolio);
		await Put_AddNote({wo_folio:wofolio, comment: NotaEdit,planta:LoginState.planta})
	}

	/** lanzadores, iniciadores y actuadores */
	useEffect(() => {
		ObtainOtsApi()
		Obtener_UserByRut()
		return () => {
			ObtainOtsApi()
			Obtener_UserByRut()
		}
	}, [])

	useEffect(() => {
		if(OtsSelected[0]?.note){
			// console.log(OtsSelected[0]?.note);
			setNotaEdit(OtsSelected[0]?.note)
		}

	}, [OtsSelected])

	function segundosAHorasMinutos(segundos) {
		const horas = Math.floor(segundos / 3600);       // Calcula las horas
		const minutos = Math.floor((segundos % 3600) / 60); // Calcula los minutos restantes
		
		// Formatea a 2 dígitos (ej: 5 → "05")
		const horasStr = horas.toString().padStart(2, '0');
		const minutosStr = minutos.toString().padStart(2, '0');
		
		return `${horasStr}:${minutosStr}`; // Devuelve "hh:mm"
	}

	const handleReasignar = async (resign) => {
		let fltUsr = UserDataCompleta.filter(usr=>usr.value===resign)[0]
		let obj = {}
		if(LoginState.cargo === "EXTERNO"){
			obj = {
				"wo_folio": woFolioAsignacion,
				"responsible":{
					"code": LoginState.rut,
					"name": fltUsr.label
				},
				"planta": LoginState.planta
			}
		}else{
			obj = {
				"wo_folio": woFolioAsignacion,
				"responsible":{
					"code": fltUsr.value,
					"name": fltUsr.label
				},
				"planta": LoginState.planta
			}
		}
		console.log(obj)
		const data = await ChangeResponsible(obj)
		if(data){
			const BkpReasign = await BkpReasignacionOT({ACTION:"ADD",DATA:{
				OT: obj.wo_folio,
				CODE: obj.responsible.code,
				NAME: obj.responsible.name,
				PLANTA: obj.planta
			}})

			ObtainOtsApi()
			setwoFolioAsignacion('')
			setSelAsignacion("")
			// console.log(data)
			setStateReasign({ ...stateReasign, ["bottom"]: false });
		}
	}
	
	useEffect(() => {
		// console.log("controlChangeOT",controlChangeOT)
		setState({ ...state, ["right"]: false })
		ObtainOtsApi()
	}, [controlChangeOT])
	
	return (
		<>
			<HeaderMenu Pag_Sel={'ot'} VisibleModal={VisibleModal} setVisibleModal={setVisibleModal} />
			
			<div className='container'>
				<div className='row'>
					{/* ESPACEADOR */}
					<div className='col-2'></div>
					{/* OTS EN PROCESO */}
						<div className='col-12 col-md-8 mb-3'>
							<div className='row'>
								<div className='col'>
									<div className='row'>
										<div className='col-12 card-header card-shadows text-center mb-4 pt-3'>
											<div className='row p-0 m-0'>
												<div className='col-10'><h5><TimelineIcon fontSize='large' color='warning'/>  OT en Proceso. ({OtsBault.length??"0"})</h5></div>
												<div className='col-2 pt-1 '><span className='puntero' onClick={()=>{
														ObtainOtsApi()
														setFechaFilter('')
													}}><RefreshIcon /></span>
												</div>
												<div className='filter-ot'>
													{
														MenuFilter?<span className='puntero' onClick={()=>setMenuFilter(!MenuFilter)}><FilterAltOffIcon color='error'/></span>:
														<span className='puntero' onClick={()=>setMenuFilter(!MenuFilter)}><FilterAltIcon/></span>
													}
												</div>
											</div>
										</div>
										{/* filtro para OT's */}
											<div className={MenuFilter?'menu-filter':'menu-filter-none'}>
												<div className=''>
													<div className='col-12'>
														<span>Filtro <FilterAltIcon fontSize='16'/></span>
													</div>
													<div className='col-12 mt-2 py-3'>
														<input
															type='date'
															className='inputFecha'
															value={FechaFilter}
															onChange={(e)=>setFechaFilter(e.target.value)}
														/>
														<span style={{position: 'absolute', left: 20, top: 4, paddingInline: 4, fontSize: "small", backgroundColor: 'white'}}>Fecha</span>
													</div>
													<div className='col-12 mt-2 py-3'>
														<input
															type='text'
															className='inputFecha'
															value={OTFilter}
															onChange={(e)=>setOTFilter(e.target.value)}
														/>
														<span style={{position: 'absolute', left: 20, top: 4, paddingInline: 4, fontSize: "small", backgroundColor: 'white'}}>Ingrese N° OT</span>
													</div>
													<div className='col-12 text-right'>
														<button className='btn btn-sm btn-danger mt-2 mr-3' onClick={()=>{
																// ObtainOtsApi()
																setOtsBault(OtsBaultBKP)
																setFechaFilter('')
																setOTFilter('')
																setMenuFilter(!MenuFilter)
															}}>Limpiar Filtro</button>
														<button className='btn btn-sm btn-info mt-2' onClick={()=>FiltroPorFecha()}>Filtrar</button>
													</div>
												</div>
											</div>
										<div className='col-12 card-shadows card-itm-ot card-body'>
											<div className='row px-2'>

											{/* ot card a repetir por cada ot encontrada del usuario */}
											{
												OtsBault.length>=1?
												OtsBault.map(ots => (
													<div key={ots.wo_folio} className={OtsSelected[0]?.wo_folio === ots.wo_folio ? 'col-12 ot-item mb-3 selected' : 'col-12 ot-item mb-3'}>
														<div className='row py-2 px-2'>
														<div className='col-12 p-0 m-0'>
																<div className='row py-2 px-2'>
																	{/* header OT */}
																	<div className='col-4 pt-1' style={{marginBottom: 0}}>
																	
																		{ots.REASIGN_&&<span title='OT reasignada'><FaArrowDownUpLock fontSize={24} color='#fb3737ff'/>&nbsp;</span>}
																		<Typography component={'span'} className='lead font-weight-normal' style={{marginBottom: 0}}>{ots.wo_folio}</Typography>
																	</div>
																	<div className='col-8 text-right pt-1' style={{marginBottom: 0}}>
																		{/* reasignar ot */}
																		{!ots.REASIGN_&&<span
																			title='Reasignar OT'
																			className='puntero'
																			onClick={()=>{
																				setwoFolioAsignacion(ots.wo_folio)
																				setStateReasign({ ...stateReasign, bottom: true })
																			}}
																		>
																			<TbStatusChange size={30} color='#A49D9D'/>
																		</span>}
																		&nbsp;&nbsp;
																		{/* ver e imprimir pdf */}
																		<span
																			title='Ver e Imprimir OT'
																			className='puntero'
																			onClick={()=>GenerarPDF_NOW(ots)}
																		>
																			<PiDownloadBold size={30} color='#A49D9D'/>
																		</span>
																		{/* enviar a revisión */}
																		<button className='btn btn-sm btn-success ml-3' onClick={()=>HandleChangeStatus(ots.wo_folio)}>Enviar a Revisión</button>
																	</div>
																	<div className='col-12 my-2'>
																		<hr className='separador' style={{padding: 0, margin:0}}/>
																	</div>
																</div>
															</div>
															{/* muestra el detalle de la OT */}
															<div className='col-12 p-0 m-0 puntero' onClick={()=>MenuCrud(ots.wo_folio,ots)}>
																<div className='row py-2 px-2'>
																																
																	<div className='col-10'>
																		<Typography component={'p'} className='font-weight-normal text-truncate' style={{paddingBottom: 0, marginBottom:0}}><b>{ots.user_assigned}</b></Typography>
																		<label className='pm-0'>
																			{String(ots.cal_date_maintenance).split("T")[0]} [{segundosAHorasMinutos(ots.duration)}]
																		</label>
																		&nbsp;|&nbsp;
																		<label style={{backgroundColor: ots.id_priorities===2?"ORANGE":
																		ots.id_priorities===3?"YELLOW":
																		ots.id_priorities===4?"SKYBLUE":
																		"RED", paddingInline: 10, borderRadius: 3, color: '#000000ff', fontWeight: '600'}}>
																			PRIORIDAD: {ots.id_priorities===2?"ALTA":ots.id_priorities===3?"MEDIA":ots.id_priorities===4?"BAJA":"URGENTE"}
																		</label>
																		&nbsp;|&nbsp;
																		<label style={{backgroundColor: '#747474ff', paddingInline: 10, borderRadius: 3, color: '#e4e4e4ff', fontWeight: '600'}}>
																			TAREA: {ots.cantidad??"0"}
																		</label>
																	</div>
																	<div className='col-12 text-right'>
																		<small style={{backgroundColor: '#747474ff', paddingInline: 8, paddingBlock: 4, borderRadius: 3, color: '#e4e4e4ff', fontSize:10}}>
																		AVANCE: <b>{ots?.completed_percentage}%</b>
																		</small>
																	</div>
																	<div className='col-12 text-truncate'>
																		<small style={{color:"#8C8C8C", fontWeight: '600'}}>Creada por {ots.created_by}</small>
																	</div>
																	<div className='col-12 text-truncate'>
																		<Typography component={'span'}>{ots.items_log_description}</Typography>
																	</div>
																</div>
															</div>

														</div>
													</div>
												))
												:<div className='col-12 text-center mt-3'><Typography component={'span'} className='lead'>SIN OTS ASIGNADAS AUN</Typography></div>
											}

											
											</div>
											
										</div>
									</div>
								</div>
							</div>
						</div>
					{/* ESPACEADOR */}
					<div className='col-2'></div>
				</div>
			</div>
			<br/>

			{/* GENERAR COMPONENETE CON EL DRAWER PARA EVITAR BUG DE REDUNDANCIA */}
			{/* DRAWER MENU CRUD */}
			<Drawer
				anchor={'right'}
				open={state['right']}
				onClose={toggleDrawer('right', false)}
			>
				<div className='container-crudmenu mb-5 mx-2'>
					<div className='row'>
						{/*  header menu crud */}
						<div className='col-12 pb-2'
							style={{
								backgroundColor: "#fff",
								right: 0,
								width: "500px",
								position: 'sticky',
								top: 0,
								zIndex: 1000,
								borderBottom: "1px solid #999999",
								paddingTop: 10
								}}>
							<div className='row'>
								<div className='col-2'>
									<ArrowBackIosIcon color='info' onClick={toggleDrawer('right', false)}/>
								</div>
								<div className='col-7'>
									Orden de trabajo
								</div>
								<div className='col-3 text-center'>
									<SaveIcon style={NotaEdit.length>=3?{color: "#1976d2", cursor: 'pointer'}:{color: "#ACACAC"}}
									titleAccess='Guardar Nota'
										onClick={NotaEdit.length>=3?()=>SaveNoteInOT(OtsSelected[0].wo_folio):null}
									/>
								</div>
							</div>
						</div>
						{/* CRUD OTs */}
						<div className='container-fluid pt-5 mb-3'>
							<div className='row card-ot-crud m-1 pb-2 shdowBan'>

									{
										OtsSelected.length?
										OtsSelected[0].personnel_path_image?<div className='col-2 d-flex p-0 m-0'><img className='cont-avatar' src={'/favicon.png'}/></div>
										:<div className='col-2 pt-2 text-center'><Avatar>
											{String(OtsSelected[0].user_assigned).split(" ")[0].substring(0,1)}
											{String(OtsSelected[0].user_assigned).split(" ").length===4?
												String(OtsSelected[0].user_assigned).split(" ")[2].substring(0,1)
												:String(OtsSelected[0].user_assigned).split(" ")[1].substring(0,1)
											}
										</Avatar></div>
										:null
									}

								<div className='col-10' data-toggle="tooltip">
									<div className='row pt-1'>
										<div className='col-12 text-01 text-truncate'>{OtsSelected.length?OtsSelected[0].user_assigned:null}</div>
										<div className='col-12'><small>{OtsSelected.length?String(OtsSelected[0]?.cal_date_maintenance).split("T")[0]:null} / {OtsSelected.length?String(OtsSelected[0]?.cal_date_maintenance).split("T")[1].substring(0,5):null}</small></div>
									</div>
								</div>
								<div className='col-12 text-truncate'>
									<Typography component={'span'} className='text-02'>Creada por {OtsSelected[0]?.created_by}</Typography>
								</div>

								<div className='col-12 mt-2'>
									<TextField
										fullWidth
										id="outlined-multiline-static"
										label="Nota"
										multiline
										rows={2}
										value={NotaEdit}
										onChange={(e)=>setNotaEdit(e.target.value)}
									/>
								</div>
								<div className='col-12' title='OT253256'>
									<Typography component={'span'}>{OtsSelected.length?OtsSelected[0].wo_folio:null}</Typography>
								</div>
							</div>
						</div>

						{/* CRUD TAREAs */}
						<div className='container-fluid mt-3 mb-4'>
							<div className='row card-ot-crud m-1 pt-2 shdowBan'>
								<div className='col-12 py-2' style={{borderBottom: "1px solid #00A4E2"}}>
									<div className='row'>
										<div className='col-6'>
												<Typography component={'span'}>Tareas</Typography>
										</div>
										<div className='col-6 text-right'>
											<Typography component={'span'}>Total: {TasksBault.length} <ArrowUpwardIcon style={{color: "#9A9A9A"}} /></Typography>
										</div>
									</div>
								</div>
								

								{/* Repetir por cada tarea en ot */}
								{
									TasksBault&&TasksBault.map(tskkk => <TaskComp 
										key={tskkk.id_work_orders_tasks}
										ModalLoadded={ModalLoadded}
										setModalLoadded={setModalLoadded}
										setTexto={setTexto}
										task={tskkk}
										controlChangeOT={controlChangeOT}
										setControlChangeOT={setControlChangeOT}
										/>)
								}
								{/* Repetir por cada tarea en ot */}

								
							</div>
						</div>
					</div>
				</div>			
			</Drawer>

			{
				ModalLoadded_ && 
				<div className='modal-ot-pfd'>
					<OtPdf_big TASK={dataOT?.TASK} OT={dataOT?.OT.wo_folio} ModalLoadded={ModalLoadded_} setModalLoadded={setModalLoadded_}/>
				</div>
			}

			{/** modal loading */}
			{
				ModalLoadded?<ModalLoaded texto={Texto} />:null
			}

			<div style={VisibleModal?{display:'block',position: 'fixed',top: '0px',left: '0px',width:'100%', height: '100vh', backgroundColor: 'rgb(0,0,0,0.8)',zIndex:'100000000000000000'}:{display:'none'}}>
				<ModalMakeMeAFileByDate VisibleModal={VisibleModal} setVisibleModal={setVisibleModal} />
			</div>

			{/** DRAWER REASIGNAR OT */}
			<Drawer
				anchor={'bottom'}
				open={stateReasign['bottom']}
				onClose={toggleDrawerReasign('bottom', false)}
			>
				<div className='container'>
					<div className='row'>
						<div className='col-12 p-3'>
							<h5>Reasignar OT: {woFolioAsignacion}</h5>
							<hr/>
							{/* componente de reasignacion de ot */}
							<div className='row'>
								<div className='col-6'>
									<FormControl fullWidth size="small">
										<InputLabel id="demo-select-small-label">Reasignar a usuario</InputLabel>
										<Select
											fullWidth
											labelId="demo-select-small-label"
											id="demo-select-small"
											label="Reasignar a usuario"
											value={SelAsignacion}
											onChange={(event)=>setSelAsignacion(event.target.value)}
										>
											{
												UserDataCompleta&&UserDataCompleta.map(usr=>(
													<MenuItem key={usr.value} value={usr.value}>{usr.label}</MenuItem>
												))
											}
										</Select>
									</FormControl>
								</div>
								<div className='col-6'>
									<button className='btn btn-primary' disabled={!SelAsignacion} onClick={async()=>handleReasignar(SelAsignacion)}>Reasignar</button>
								</div>
							</div>
						</div>
					</div>			
				</div>			
			</Drawer>

		</>
	)
}


